import { useLocation, useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';

// Routes where we hide the floating coach button (we don't want it on the
// Coach page itself, or on full-screen overlays / detail pages where it would
// cover content like message composers).
const HIDDEN_ROUTES = [
  '/coach',
  '/dm',                 // matches /dm AND /dm/:user_id
  '/feed/post',          // post detail has its own bottom composer/send button
  '/onboarding',
  '/login',
  '/setup-username',
  '/auth',
];

function isHidden(pathname) {
  return HIDDEN_ROUTES.some(p => pathname === p || pathname.startsWith(p + '/'));
}

export default function FloatingCoachButton() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (isHidden(pathname)) return null;

  return (
    <motion.button
      onClick={() => navigate('/coach')}
      aria-label="Talk to your AI Coach"
      data-testid="floating-coach-btn"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ type: 'spring', stiffness: 300, damping: 22, delay: 0.15 }}
      whileTap={{ scale: 0.92 }}
      whileHover={{ scale: 1.06 }}
      className="fixed z-40 bottom-24 right-4 sm:right-6 w-14 h-14 rounded-full text-white shadow-2xl flex items-center justify-center border-b-4"
      style={{
        background: 'linear-gradient(135deg, #6366F1 0%, #4F46E5 60%, #1CB0F6 100%)',
        borderBottomColor: '#3730A3',
        boxShadow: '0 8px 28px rgba(79, 70, 229, 0.45)',
      }}
    >
      <span
        aria-hidden="true"
        className="absolute inset-0 rounded-full"
        style={{
          background: 'radial-gradient(circle at 30% 25%, rgba(255,255,255,0.35), transparent 60%)',
        }}
      />
      <Sparkles size={26} strokeWidth={2.8} />
      <span
        className="absolute -top-1 -right-1 text-[9px] uppercase font-extrabold px-1.5 py-0.5 rounded-full bg-[#FFC800] text-[#3F2A00] shadow"
      >
        AI
      </span>
    </motion.button>
  );
}
